import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useGetMyProfile } from '@/api';
import { TshirtIcon } from '@/icons';
import { AvatarDecorateModal, useProfileAvatarSave, useTrackedAvatarSave } from '@/shared/features/avatar-decorate';
import { FullBodyAvatar } from '@/shared/features/user-avatar';
import { Button } from '@/ui_v3';

/**
 * /profile/edit 상단 아바타 영역 (Figma 605:12012).
 * 폼 카드 최상단에 위치하는 그라데이션 박스 + 전신 아바타(60×80) + "아바타 꾸미기" 버튼.
 */
export const ProfileAvatarCard = () => {
  const {
    t
  } = useTranslation('common');
  const {
    data: myProfile
  } = useGetMyProfile();
  const [isModalOpen, setModalOpen] = useState(false);
  const {
    save,
    isSaving
  } = useProfileAvatarSave();
  const avatarData = myProfile?.data.avatarData ?? null;
  const trackedSave = useTrackedAvatarSave(save, 'profile_edit', avatarData);
  const handleOpen = () => {
    logger.track('open_avatar_decorate_modal', {
      from: 'profileEdit'
    });
    setModalOpen(true);
  };
  return <>
      <div className="flex w-full flex-col items-center gap-md rounded-md bg-gradient-to-b from-[#f4f7ff] from-[70%] to-white px-xl pb-none pt-lg">
        <FullBodyAvatar avatarData={avatarData ?? {}} pixelHeight={80} data-sentry-element="FullBodyAvatar" data-sentry-source-file="ProfileAvatarCard.tsx" />
        <Button variant="contained" intent="strong" size="sm" rounded="full" leftSlot={<TshirtIcon size="xs" color="#fff" />} onClick={handleOpen} data-sentry-element="Button" data-sentry-source-file="ProfileAvatarCard.tsx">
          {t('avatarDecorate.openButton')}
        </Button>
      </div>
      {isModalOpen && <AvatarDecorateModal initialAvatar={avatarData} onSave={trackedSave} isSaving={isSaving} onClose={() => setModalOpen(false)} />}
    </>;
};